import React, { HTMLAttributes } from 'react';
import { Icon } from '../Icon';
import { Button } from '../Button';

export interface SuccessModalDialogProps extends HTMLAttributes<HTMLElement> {
  /** Attach a custom class to the input container */
  className?: string;
  /** Children to be displayed in the modal body */
  children?: string | string[] | React.ReactNode;
  /** title on the modal */
  title?: string; 
  /** Icon type, defaults to checkmark */
  icon?: string; 
  /** link cta element */
  linkText?: string;
  /** on close method passed from parent */
  onClose?: () =>  void;
}

const SuccessModalDialog = (props: SuccessModalDialogProps) => {
//TODO: add animatied success icon
  const {
    children, 
    title, 
    icon = 'Check',
    linkText, 
    onClose
  } = props; 
  
  return (
    <div className='ps-modal__dialog--success'>
      <span className='ps-modal__success-icon-wrapper'>
        <Icon name={icon} wrapper='circle' inverted={true}/>
      </span>
      <h2 className='ps-modal__title'>{title}</h2>
      <div className='ps-modal__children'>{children}</div>
      <Button variant="link" onClick={onClose} className='ps-modal__success-link'>{linkText}</Button>
    </div>
  );
};

SuccessModalDialog.displayName = 'SuccessModalDialog';
export { SuccessModalDialog };